module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("10")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("Enter Raoul")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _vm._v("ell Block A in Memphis’s Criminal Courts building, which served as death row, had been specially converted for Ray’s arrival. The security precautions were extraordinary. There were six individual cells, each with a single bunk, a toilet, and a washbasin. All were empty so that Ray could be randomly transferred, never spending two consecutive nights in the same cell. His food came from the prison mess and no one there knew which portion went to him. When taken into the prison yard, not only did two guards escort him, but also he was allowed only into a small corner hidden from any outside view. And at least two guards were always with him in the cell block. The entire section was brilliantly lit with large standing lights that were never turned off, forcing Ray often to put a pillow over his head to sleep."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-1",
      "id": "ch10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Microphones hung conspicuously from the ceiling. Cameras in the corners transmitted images monitored by the guards outside the bars. Sheriff Morris had a speaker and monitor installed in his office, two floors below Ray. Cameras even monitored Ray when he used the toilet and showered."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-2",
      "id": "ch10-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Arthur Hanes, Sr. and Jr., visited, they were assured by the prosecutors that the microphones were turned off, but they took no chances. They lay with Ray on their backs on the cell’s cement floor, their heads close together, whispering softly. Still, Hanes senior worried that if the television cameras filmed them, someone could read their lips. Hanes also ran the shower in the "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("background in the hope it would drown out their conversations in case the ceiling microphones were on.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-10-1",
      "id": "fn10-1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At their first meeting, Hanes looked at Ray and said, “All right, Jimmy, let’s start talking. From your breakout on April 23, 1967, to June 8 when they picked you up in London.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-3",
      "id": "ch10-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray began to relate an astonishing story. The Haneses had to pass everything to Huie, since Judge W. Preston Battle, the jurist who had been assigned the case, rejected Huie’s request to meet personally with Ray. Eventually, Ray also sent Huie handwritten letters and notes, including even crude hand-drawn maps of places he had visited as a fugitive. Because of their cumulative size these writings were dubbed “the 20,000 Words.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Huie had agreed to wait to publish until after the verdict, but instead signed a deal with "), _c('i', [_vm._v("Look")]), _vm._v(" magazine to tell Ray’s story before the trial."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-10-2",
      "id": "fn10-2"
    }
  }, [_vm._v("†")])]), _vm._v(" The first of three installments ran in the November 12, 1968, issue, and was titled “The Story of James Earl Ray and the Conspiracy to Kill Martin Luther King.” It followed Ray from his escape from the Missouri State Penitentiary for four months through his stay in Montreal, Canada, in August 1967 and often quoted from Ray’s letters to Huie. It also introduced his creative alibi."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-10-3",
      "id": "fn10-3"
    }
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray described how, in the seventh year of a twenty-year sentence, he escaped from his maximum-security jail in Missouri by scaling a twenty-three-foot wall. He then spent three months at menial jobs, maintaining a low profile in Chicago, Alton, and Quincy, Illinois.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-July, Ray drove to Montreal, where he hoped to get seaman’s papers and a job on a ship so that he could leave North America. As a result, he “spent his days and evenings with ‘the boats’” along the waterfront, Huie wrote. “He frequented Neptune Tavern, 121 West Commissioners Street.… On his third or fourth night in the Neptune, Ray says he ‘sort of let the word get around that he had had a little trouble down in the States, that he was looking for ID and capital, and just might be available for activities that didn’t involve too much "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("risk.’ This resulted in a contact. A man whom Ray calls Raoul and describes to me as being a blond Latin about 35, and whom Ray took to be a seaman, showed interest in him. They began cautious verbal exploration, with Raoul hinting that if Ray was willing to assist certain projects, Raoul might be able to provide Ray ID and capital. Ray says this exploration continued during ‘at least eight meetings’ over a period of three weeks.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-4",
      "id": "ch10-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Raoul had promised the possibility of a passport or work on a ship, “Ray’s next action was one that I have found to be typical of him,” wrote Huie. “He never puts all his eggs in one basket.” Ray tried to get a Canadian passport on his own by meeting a Canadian woman who might vouch that she had known him for at least two years, a requirement he mistakenly thought was necessary for a passport. After buying a fashionable new wardrobe, Ray set out for a premier Canadian resort—Gray Rocks Inn—where he did meet a woman and had a brief affair. But when he eventually discovered that she was employed by the Canadian government, he dropped the idea of asking her for help on the passport and instead returned to Raoul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From August 8 to the 18th, Ray says he talked at least five more times with Raoul at the Neptune Tavern. And Raoul made him this proposition:")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "1",
      "cellspacing": "1",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent1a"
  }, [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "82%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indenta"
  }, [_vm._v("That Ray would meet Raoul in the railroad station at Windsor at 3 p.m. on Monday, August 21.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent-t"
  }, [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indents"
  }, [_vm._v("That Ray would make several trips across the border from Windsor to Detroit for Raoul, using both the bridge and tunnel border crossings, carrying packages concealed in the old red Plymouth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent-t"
  }, [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indents"
  }, [_vm._v("That Ray would then sell the Plymouth and go by train or bus to Birmingham, Ala. There, Ray would lie low, take no risks, pull no hold ups, accumulate a little ID, and wait for instructions by general delivery mail.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent-t"
  }, [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indents"
  }, [_vm._v("That Raoul would pay ‘living expenses’ and also come to Birmingham and buy Ray a ‘suitable car.’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent-t"
  }, [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indents"
  }, [_vm._v("That after a few weeks or months, after a little joint activity, Raoul would pay Ray $12,000 and give him a passport and ‘other ID’ and help him go ‘Anywhere in the world.’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indent-t"
  }, [_vm._v("6.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "hang-indents"
  }, [_vm._v("That Ray would ask no questions.… Raoul did, however, reveal to Ray that he [Raoul] had spent some of his time in New Orleans, and he gave Ray a New Orleans telephone number."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-5",
      "id": "ch10-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Ray told Huie “I didn’t know what to do.” On the one hand, if he accepted Raoul’s offer he had to return to the States, where he risked being sent back to the Missouri State Penitentiary. On the other hand, “I was running out of capital again, and I didn’t want to risk another hold-up in Canada. I couldn’t get on a ship. I couldn’t get I.D.” So, Ray said, he accepted Raoul’s offer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("In the second installment in "), _c('i', [_vm._v("Look")]), _vm._v("—“I Got Involved Gradually, and I Didn’t Know Anybody Was to Be Murdered”—Huie began by informing the reader that he had done his own extensive investigation. He had personally traveled to Chicago, Montreal, Ottawa, Los Angeles, and Birmingham and Selma, Alabama. As a result of that reporting, Huie concluded:")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That the plot to murder Martin Luther King, Jr., existed as early as August 15, 1967, eight months prior to the murder on April 4, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That Ray was drawn unknowingly into this plot in Montreal on August 18, 1967, and thereafter moved as directed by the plotters.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("“That as late as March 23, 1968, less than two weeks before the murder with which he is charged, Ray did not know that the plot included the murder or that it was aimed in any way at Dr. King.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch10-10-6",
      "id": "ch10-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this article, Huie described in great detail how Ray, over seven months, made various trips at Raoul’s direction. At different times he lived in Birmingham, Mexico, and then Los Angeles. He did some smuggling for Raoul, and in return Raoul periodically gave him money, totaling $8,200.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On March 15, 1968, Ray received the directive from Raoul for which he had been waiting. “He was wanted in Selma and Birmingham, Ala.,” wrote Huie. Ray drove through New Orleans and spent the night of Friday, March 22, in Selma. The next day he left for Atlanta.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Huie wrote in his own summary to this second article: “The outline of the plot to murder Dr. King now begins to become visible to me. It may not be visible to my readers because, until Ray has been tried, I cannot reveal all that I have found to be true. But from what I know, from what I have learned from Ray, and from my investigative research, [the plot’s ringleaders were] calculating men who wanted to use King’s murder to trigger violent conflict between white and Negro citizens.” King was to be murdered during the 1968 election year, and it was to be done “not while he was living quietly at his home in Atlanta, but at some dramatic moment,” preferably in Birmingham, Montgomery, or Selma, “since these cities were milestones in his career as an advocate of racial change.” Moreover, Huie wrote, King “was to be murdered by a white man, or white men, who would be described as ‘Southerners’ and racists.” And finally, “there was no necessity, after the murder, for the murderer or murderers to be murdered to prevent a trial or trials—because a trial or trials could yield extra dividends of hatred and violence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The editors of "), _c('i', [_vm._v("Look")]), _vm._v(" closed the November 26 issue by promising that “in a future issue, William Bradford Huie plans to tell in detail the personal story that may not be developed at the trial—the activities of James Earl Ray between March 23 and the day that he was arrested in London.”")]), _vm._v(" "), _c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-1",
      "id": "fn10-10-1"
    }
  }, [_vm._v("*")]), _vm._v(" In September, the Haneses filed a motion before the trial judge on the Ray case, asking for the “inhumane” conditions to be improved, and also to be allowed to have private conversations with their client.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-2",
      "id": "fn10-10-2"
    }
  }, [_vm._v("†")])]), _vm._v(" Huie said Ray agreed to the early publication so long as Huie stopped his narrative at March 23, 1968, eleven days before the assassination. That installment was still set for publication after the trial. The early articles earned Huie a contempt citation, since the court had placed a ban on pretrial publicity, but Judge Battle died before he ever punished Huie.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10-3",
      "id": "fn10-10-3"
    }
  }, [_vm._v("‡")])]), _vm._v(" Ray’s version, as originally given to Huie, is presented here without any comment or correction. It is discussed in detail in Chapters 19 through 26. Any quotations in this chapter refer to one of three Huie installments in "), _c('i', [_vm._v("Look")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3128517b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter10.vue
// module id = 105
// module chunks = 0